/* eslint-disable no-async-promise-executor */
import ajax from "@/plugins/ajax";
const state = {
  userInfo: {},
  packageInfo: {},
};

const mutations = {
  setUserInfo(state, data) {
    state.userInfo = data;
    sessionStorage.setItem("dfx-user", JSON.stringify(data));
  },
  setTranslate(state, data) {
    state.packageInfo = data;
    sessionStorage.setItem("dfx-translate", JSON.stringify(data));
  },
};

const getters = {};

const actions = {
  getUserInfo({ commit }) {
    return new Promise(async (resolve) => {
      let userInfo = {};
      await ajax.get("/user/userInfo/info").then((data) => {
        if (data.code === 200) {
          userInfo = data.result;
        }else{
          userInfo = data
        }
      });
      commit("setUserInfo", userInfo);
      resolve(userInfo);
    });
  },
  getPackageInfo({ commit }) {
    return new Promise(async (resolve) => {
      try {
        await ajax.get("/user/userInfo/packageNum").then((data) => {
          if (data.code === 200) {
            commit("setTranslate", data.result);
            resolve(data.result);
          }
        });
      } catch (error) {
        resolve({});
      }
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
